export default {
	// url: "http://localhost:55490/api/v0/",
	// tokenService: "http://localhost:55490/token",

	url: process.env.VUE_APP_ROOT_API,
	// dataProcessorApiUrl: process.env.VUE_APP_DATAPROCESSORROOT_API,
	tokenService: process.env.VUE_APP_ROOT_API_TOKEN,
	azureFunctionApiUrl: process.env.VUE_APP_AZURE_FUNCTION_API
}
